<template>
  <v-app>
    <Nav />
    <v-main>
      <v-container class="thanks">
        <h1>
          Thank you for your order!
        </h1>
        <div v-if="customer">
          <h4 class="text-h4">Thank you for being a valued Ruff Tuff Authorized Reseller!</h4>
          <p class="text-body-1">You will receive further details regarding this order from Ruff Tuff shortly. Shipping will be added at the completion of the order processing, and you will be billed according to your individual credit terms with Ruff Tuff. If you have any questions, please call us toll-free at 800-453-8830 during business hours or email us at <a href="mailto:customerservice@rufftuff.com">customerservice@rufftuff.com</a>.</p>
        </div>

        <div v-if="!customer">
          <h4 class="text-h4">This is your temporary order number: T-{{order.orderId.substring(0,6)}}.</h4>
          <p class="text-body-1">Within a few minutes you should receive a receipt for payment from Authorize.net at the e-mail address you provided. Then, within 15-20 minutes, you should receive a more detailed confirmation of your order from Ruff Tuff. If you do not receive these or if you have any questions, please call us toll-free at 800-453-8830 during business hours or email us at <a href="mailto:customerservice@rufftuff.com">customerservice@rufftuff.com</a>.</p>
          <p class="text-body-1">Your purchase will appear on your credit card statement as "RUFF TUFF PRODUCTS LLC."</p>
        </div>

      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'
import Nav from '@/components/Nav'

export default {
  components: {
    Nav,
  },
  computed: {
    ...mapState([
      'customer',
      'order'
    ]),
  }
}
</script>

<style lang="scss">
.thanks h1 {
  font-family: $heading-font-family;
  text-transform: uppercase;
  text-align: left;
  margin: 10px 0;
  padding-left: 30px;
  padding-right: 30px;
  font-weight: 600;
  font-size: 1.8rem;

  @media screen and (min-width: 600px) {
    font-size: 3rem;
    padding-left: 0;
    padding-right: 0;
    margin: 50px 0 0;
  }
}

.thanks h4 {
  font-family: $heading-font-family;
  text-align: left;
  margin: 0;
  padding-left: 30px;
  padding-right: 30px;
  font-weight: 600;
  font-size: 1.8rem;

  @media screen and (min-width: 600px) {
    font-size: 2rem;
    padding-left: 0;
    padding-right: 0;
    margin: 0 0 15px;
  }
}
</style>
